import { render, staticRenderFns } from "./modalRecomendacionesUso.vue?vue&type=template&id=55f75e9e&scoped=true"
import script from "./modalRecomendacionesUso.vue?vue&type=script&lang=js"
export * from "./modalRecomendacionesUso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f75e9e",
  null
  
)

export default component.exports